import {componentLibraries as Components} from "./useComponentsLibrary.js";
import { useFormFieldTypes } from "./useFormFieldTypes.js";

export function useFormFieldBuilder(data = {}) {
    const { formFieldTypes } = useFormFieldTypes();
    let formData = {...data, isRequired: data.required}
    switch (data.type) {
        
        case formFieldTypes.RADIO:
            return {component: Components.FormRadioGroup, data:formData};
        case formFieldTypes.CHECKBOX:
            return {component: Components.FormCheckboxGroup, data:formData};
        case formFieldTypes.TEXTAREA:
            return {component: Components.FormTextArea, data:formData};
        case formFieldTypes.SELECT:
            return {component: Components.FormSelect2, data:formData};
        case formFieldTypes.SELECTMULTIPLE:
            return {component: Components.FormSelect2, data:{ ...formData, multiple: true }};
        case formFieldTypes.DATE:
            return {component: Components.FormDate, data:{ ...formData, maxDate: 'today' }};
        case formFieldTypes.DATETIME:
            return {component: Components.FormDate, data:{ ...formData, maxDate: 'today' }};
        case formFieldTypes.FILE:
            return {component: Components.FormSelect, data:formData};
        case formFieldTypes.URL:
            return {component: Components.FormInput, data:{ ...formData, type: "url" }};
        case formFieldTypes.NUMBER:
            return {component: Components.FormInput, data:{ ...formData, type: "number" }};
        case formFieldTypes.EMAIL:
            return {component: Components.FormInput, data:{ ...formData, type: "email" }};
        default:
            return {component: Components.FormInput, data:formData}; 
    }

}